export default __webpack_public_path__ + "static/media/轮播首图13.2dab7c28.png";